import { useReducer } from 'react';
import { PolicyHolderType } from '../common/CommonTypes';
import {
    CustomerContextState,
    CustomerState
} from '../../context/CustomerContext';

export type Action = { type: 'set-customer'; customer: PolicyHolderType };

const CustomerReducer = (state: CustomerState, action: Action) => {
    switch (action.type) {
        case 'set-customer': {
            return {
                ...state,
                customer: action.customer
            };
        }
        default: {
            return state;
        }
    }
};

function useCustomerTypes(initialState?: CustomerState): CustomerContextState {
    if (initialState === undefined) {
        initialState = {
            customer: undefined
        };
    }

    const [customerTypes, dispatch] = useReducer(CustomerReducer, initialState);

    const { customer } = customerTypes;

    const setCustomer = (customer: PolicyHolderType): void => {
        dispatch({ type: 'set-customer', customer });
    };

    return {
        customer,
        setCustomer
    };
}

export default useCustomerTypes;
